import React, { useMemo, useState } from 'react';

import Modal from 'components/shared/Modal';
import Button from 'components/shared/Button';

import type { CollectionName, NamedCollection, UncollectedCollection } from 'domains/photos';

type RenameCollectionModalProps = {
  collections: NamedCollection[];
  current: NamedCollection | UncollectedCollection;
  onConfirm: (current: CollectionName, change: string) => void;
  onCancel: () => void;
};

function RenameCollectionModal({
  current,
  collections,
  onCancel,
  onConfirm,
}: RenameCollectionModalProps) {
  const [rename, setRename] = useState('');

  const disableConfirm = useMemo(
    () => rename === '' || !!collections.find((c) => c.name === rename),
    [rename, collections]
  );

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (disableConfirm) return;

    onConfirm(current.name, rename);
  }

  const buttons = (
    <React.Fragment>
      <Button
        type="confirm"
        htmlType="submit"
        form="rename-collection-form"
        disabled={disableConfirm}
      >
        Confirm
      </Button>
      <Button type="cancel" onClick={onCancel}>
        Cancel
      </Button>
    </React.Fragment>
  );

  return (
    <Modal
      labelledBy="rename-collection-modal"
      title={`Rename collection: ${current.name || 'Uncollected'}`}
      modalClass={['rename-collection-modal']}
      lastFocusedElementId={`${current.name}-${current.name}-navigation-tile`}
      onClose={onCancel}
      primaryFooterGroup={buttons}
    >
      <form id="rename-collection-form" onSubmit={handleSubmit}>
        <label htmlFor="rename-collection">New Name:</label>
        <input id="rename-collection" onChange={(e) => setRename(e.target.value)} value={rename} />
      </form>
    </Modal>
  );
}

export default RenameCollectionModal;
